import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFailed = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M24 4C12.94 4 4 12.94 4 24s8.94 20 20 20 20-8.94 20-20S35.06 4 24 4m10 27.18L31.18 34 24 26.82 16.82 34 14 31.18 21.18 24 14 16.82 16.82 14 24 21.18 31.18 14 34 16.82 26.82 24z" })
});
export default SvgFailed;
